import { Text } from '@chakra-ui/react';
interface Props {
  message?: string;
}

const ErrorMessage = ({ message, ...props }: Props) => {
  if (!message) {
    return null;
  }

  return (
    <Text role='error-message' color={'red.500'} fontSize={'sm'} {...props}>
      {message}
    </Text>
  );
};

export default ErrorMessage;
